import { dataLayerConfig } from '@aspendental/shared-components-web';
import { Stack } from '@mui/material';
import { Dispatch, SetStateAction, useEffect } from 'react';

import PatientInformation from '@src/components/Forms/PatientInformation';
import useScheduleQuestionsStore from '@src/store/schedule-questions.store';
import { handlePageLeave } from '@src/utils/handle-page-leave';

interface IPatientInformationStepProps {
	smartyKey: string;
	setIsStepSubmitting: (value: SetStateAction<boolean>) => void;
	isStepSubmitting: boolean;
	setSchedulePopupError: (value: SetStateAction<boolean>) => void;
	setModalType: Dispatch<SetStateAction<'existingConsultation' | 'promptToCall'>>;
}

export default function PatientInformationStep({
	smartyKey,
	setIsStepSubmitting,
	isStepSubmitting,
	setSchedulePopupError,
	setModalType,
}: IPatientInformationStepProps) {
	const questionsAnswers = useScheduleQuestionsStore((state) => state.questionsAnswers);

	useEffect(() => {
		dataLayerConfig({
			event: 'scheduleform_step2',
		});
	}, []);

	useEffect(() => {
		document.addEventListener('click', handlePageLeave, true);

		return () => {
			document.removeEventListener('click', handlePageLeave, true);
		};
	}, [questionsAnswers]);

	return (
		<Stack direction="column" spacing={2.5} data-test-id="section_patient_information_step">
			<PatientInformation
				smartyKey={smartyKey}
				setIsStepSubmitting={setIsStepSubmitting}
				isStepSubmitting={isStepSubmitting}
				setSchedulePopupError={setSchedulePopupError}
				setModalType={setModalType}
			/>
		</Stack>
	);
}
